<script>
    export default {
        props: {
            value: [String, Number, Array],
            label: String,
            labelWidth: String,
            labelValue: [String, Number],
            labelOptions: Array,
            labelField: String,
            labelDisabled: {
                type: Boolean,
                default: false,
            },
            add: {
                type: Boolean,
                default: false,
            },
            field: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            autosize: {
                type: Boolean,
                default: false,
            },
            minRows: {
                type: Number,
                default: 2,
            },
            maxRows: {
                type: Number,
                default: 10,
            },
        },
        data() {
            return {}
        },
        methods: {
            change_value(v) {
                this.$emit('input', v);
                this.$emit('change', v);
                if (this.field) {
                    this.$emit('change-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_value(v) {
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            change_label(v) {
                this.$emit('update:labelValue', v);
                this.$emit('change-label', v);
                if (this.labelField) {
                    this.$emit('change-label-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_label(v) {
                this.$emit('update:labelValue', v);
                if (this.labelField) {
                    this.$emit('input-label-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            click_add() {
                this.$emit('add');
            },
        },
        computed: {
            show_append() {
                return this.show_add;
            },
            show_add() {
                if (this.disabled) return false;
                return this.add;
            },
            size() {
                if (this.autosize) {
                    return {
                        minRows: this.minRows,
                        maxRows: this.maxRows,
                    };
                } else return null;
            },
        },
        watch: {},
        components: {},
        mounted() {

        },
        destroyed() {

        },
    }
</script>
<template>
    <form-group class="form-textarea" :label-width="labelWidth" :append="show_append" :label="label||(labelOptions?' ': '')">
        <el-select
                slot="labelSelect"
                v-if="labelOptions"
                :value="labelValue"
                :disabled="labelDisabled"
                @change="change_label"
                @input="input_label">
            <el-option v-for="item in labelOptions"
                       :value="item.value"
                       :label="item.label"
                       :key="item.value">
            </el-option>
        </el-select>
        <el-input
                :value="value"
                @change="change_value"
                type="textarea"
                :autosize="size"
                @input="input_value"
                :disabled="disabled">
        </el-input>
        <el-button
                v-if="show_add"
                slot="append"
                icon="el-icon-plus"
                title="Добавить"
                @click="click_add">
        </el-button>
    </form-group>
</template>
